/** Roles con permisos de gestión (alineado a backend permissions + catálogo SIGC). */
export const ROLES_CRUD = [
  'SuperAdmin',
  'Administrador',
  'ADMIN_CEDIA',
  'ADMIN_IES',
];
